import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  HeaderContainer,
  Logo,
  Button,
  HeaderLeft,
  HeaderRight,
  OpenUserMenu,
  ReturnButton,
  UserMenu,
} from './styles';
import { User } from '../../types/user';
import Icon from '../Section/Icon';
import iconOpenCollapse from '../../static/img/icon-open-collapse.svg';
import iconReturn from '../../static/img/icon-open-menu.svg';
import svg from '../../static/img/logo-globo.svg';
import { Categories, Actions, Labels } from '../../types/gtm';
import environmentConfig from '../../config/environment-configs';

export interface HeaderUserProps {
  user?: User;
  screenMenu?: string;
  onLogout?: () => void;
  showReturn?: boolean;
  labelMenu?: string;
  onReturn?: (helpers: {
    handleSmartReturn: () => void;
    handleInternalReturn: () => void;
  }) => void;
}

export default function Header({
  user,
  onLogout,
  showReturn,
  onReturn,
  labelMenu,
  screenMenu = Categories.Home,
}: HeaderUserProps) {
  const history = useHistory();
  const [open, setOpen] = useState<boolean>(false);
  window.dataLayer = window.dataLayer || [];

  function handleSmartReturn() {
    window.location.href = environmentConfig.ACCOUNT_MANAGEMENT_DEFAULT_DNS_URL;
  }

  function handleInternalReturn() {
    history.goBack();
  }

  function handleReturnClick() {
    if (onReturn) {
      onReturn({ handleSmartReturn, handleInternalReturn });
    } else {
      handleSmartReturn();
    }
  }

  return (
    <HeaderContainer>
      <HeaderLeft>
        {showReturn && (
          <ReturnButton onClick={handleReturnClick}>
            <>
              <Icon svg={iconReturn} alt="icon-return" /> <span>Voltar</span>
            </>
          </ReturnButton>
        )}
      </HeaderLeft>

      <a
        href={environmentConfig.ACCOUNT_MANAGEMENT_DEFAULT_DNS_URL}
        onClick={handleSmartReturn}
        aria-label="Voltar para a página inicial da Conta Globo"
      >
        <Logo>
          <img src={svg} alt="Conta Globo" />
        </Logo>
      </a>

      <HeaderRight>
        {user && (
          <UserMenu
            headerWithReturnButton={showReturn || false}
            onClick={() => {
              if (!open) {
                window.dataLayer.push({
                  event: 'customEventUserInteraction',
                  event_category: screenMenu,
                  event_action: Actions.ClickMenu,
                  event_label:
                    screenMenu === Categories.Home ? Labels.Home : labelMenu,
                  bd_suser_code: user?.globoId,
                });
              }

              setOpen(!open);
            }}
          >
            <Button aria-expanded={open} aria-haspopup="true">
              <span>{user.email ? user.email : user.fullName}</span>
              <Icon openCollapsible={open} svg={iconOpenCollapse} />
            </Button>

            {open ? (
              <OpenUserMenu>
                <span className="top-bot" />
                <span className="top-bot top-bot-border" />
                <span>{user.fullName}</span>
                <br />
                <a
                  href="#/logout"
                  className="logout"
                  onClick={() => {
                    if (onLogout) {
                      onLogout();
                    }
                    window.dataLayer.push({
                      event: 'customEventUserInteraction',
                      event_category: screenMenu,
                      event_action: Actions.ClickLogoutMenu,
                      event_label:
                        screenMenu === Categories.Home
                          ? Labels.Home
                          : labelMenu,
                      bd_suser_code: user?.globoId,
                    });
                  }}
                >
                  Sair da Conta Globo
                </a>
              </OpenUserMenu>
            ) : null}
          </UserMenu>
        )}
      </HeaderRight>
    </HeaderContainer>
  );
}
